import axios from 'axios';
import { DEFAULT_WARNINGS } from '../config/defaultWarnings';

export const getWarnings = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}/warnings/all`);
        const data = response.data;
        if (Array.isArray(data) && data.length > 0) {
            return data;
        }
        return DEFAULT_WARNINGS;
    } catch (error) {
        console.error('Error fetching warnings:', error);
        return DEFAULT_WARNINGS;
    }
};
